import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};



export type AccountConfigEntity = CoreBaseEntity & {
  __typename?: 'AccountConfigEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accessTokenDuration: Scalars['String'];
  refreshTokenDuration: Scalars['String'];
  accountId: Scalars['String'];
  pwdchangefrequency: Scalars['Float'];
  repeatPwd: Scalars['Float'];
};

export type AccountDebtor = {
  __typename?: 'AccountDebtor';
  accountId?: Maybe<Scalars['String']>;
  lDebtorId?: Maybe<Scalars['Float']>;
  propertyName?: Maybe<Scalars['String']>;
  debtorAccountName?: Maybe<Scalars['String']>;
  contractLotNo?: Maybe<Scalars['String']>;
};

export type AccountDeleteInput = {
  ID: Scalars['String'];
};

export type AccountEntity = CoreBaseEntity & {
  __typename?: 'AccountEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  regNo?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['JSON']>;
  contactPerson?: Maybe<Scalars['JSON']>;
  user?: Maybe<Array<UserAccSoftwareEntity>>;
  newsFeed: Array<NewsFeedEntity>;
  serviceRequests?: Maybe<Array<ServiceRequest>>;
  roles?: Maybe<Array<RoleEntity>>;
  roleUsers?: Maybe<Array<RoleUserEntity>>;
  sNumberFormats?: Maybe<Array<SNumberFormat>>;
  subscription: Array<SubscriptionEntity>;
  termsConditions: Array<TermsConditionsEntity>;
  bankAccount: Array<FromBankAccountEntity>;
  accountSettings: Array<SAccountSettings>;
  paymentTransactions?: Maybe<Array<SPaymentTransaction>>;
  currency?: Maybe<CurrencyEntity>;
  gatewayVersion?: Maybe<Scalars['String']>;
};


export type AccountEntityNewsFeedArgs = {
  IsFindLatestPostDate?: Maybe<Scalars['Boolean']>;
};

export type AccountInput = {
  ID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  code: Scalars['String'];
  email: Scalars['String'];
  regNo: Scalars['String'];
  contactNo: Scalars['String'];
  address?: Maybe<AddressInput>;
  contactPerson?: Maybe<ContactPersonInput>;
  currencyId?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
};

export type Address = {
  __typename?: 'Address';
  siteName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  AddressType?: Maybe<AddressType>;
};

export type AddressInput = {
  siteName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  AddressType?: Maybe<AddressType>;
};

export enum AddressType {
  Primary = 'PRIMARY',
  Delivery = 'DELIVERY',
  Site = 'SITE'
}

export type AssignTo = {
  __typename?: 'AssignTo';
  ID: Scalars['String'];
  name: Scalars['String'];
};

export type AttachmentByRefIdAndRefTableInput = {
  refId: Scalars['String'];
  refTable: Scalars['String'];
  module?: Maybe<Scalars['String']>;
};

export type AttachmentData = {
  __typename?: 'AttachmentData';
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type AttachmentEntity = CoreBaseEntity & {
  __typename?: 'AttachmentEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  refTable?: Maybe<Scalars['String']>;
  refType?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['String']>;
  mediaType: Scalars['String'];
  resourceUrl?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  bucketFileName?: Maybe<Scalars['String']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  commonStatus: CommonStatus;
  fileSize: Scalars['Float'];
  requestActivity: RequestActivity;
  requestFollowUp: RequestFollowUp;
  requestEstimation: RequestEstimation;
  newsFeed?: Maybe<NewsFeedEntity>;
  account: AccountEntity;
};

export type AttachmentModel = {
  file?: Maybe<Scalars['Upload']>;
};

export type AuditEntity = {
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
};

export type BaseInput = {
  ID?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
};

export type BusinessInsightOutput = {
  __typename?: 'BusinessInsightOutput';
  openCase?: Maybe<Scalars['Float']>;
  resolvedCase?: Maybe<Scalars['Float']>;
  inProgressCase?: Maybe<Scalars['Float']>;
  closedCase?: Maybe<Scalars['Float']>;
  monthText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type CityEntity = CoreBaseEntity & {
  __typename?: 'CityEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  stateId: Scalars['String'];
  commonStatus: CommonStatus;
  state: StateEntity;
  postcode: Array<PostcodeEntity>;
};

export type CityInput = {
  name?: Maybe<Scalars['String']>;
  stateID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type CloudStorageOutput = {
  __typename?: 'CloudStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  Url: Scalars['String'];
  MediaType: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  PrivateUrl?: Maybe<Scalars['String']>;
};

export enum CommonStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Block = 'BLOCK'
}

export type CompanyData = {
  __typename?: 'CompanyData';
  name?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Float']>;
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  name?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type ContactPersonInput = {
  name?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type CoreBaseEntity = {
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
};

export type CountryEntity = CoreBaseEntity & {
  __typename?: 'CountryEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  commonStatus: CommonStatus;
  state: Array<StateEntity>;
};

export type CountryInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type CreateAuditInput = {
  createdBy?: Maybe<Scalars['String']>;
};

export type CreateServiceRequestCriteria = {
  __typename?: 'CreateServiceRequestCriteria';
  serviceRequestAreaType: Array<Scalars['String']>;
  publicArea?: Maybe<Array<Scalars['String']>>;
  units?: Maybe<Array<UnitModel>>;
  requestType?: Maybe<Array<Scalars['String']>>;
  assignTo: Array<AssignTo>;
  tenantInfo?: Maybe<Array<TenantInfo>>;
};

export type CurrencyEntity = CoreBaseEntity & {
  __typename?: 'CurrencyEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  commonStatus: CommonStatus;
  account: Array<AccountEntity>;
};

export type CurrencyExchangeEntity = {
  __typename?: 'CurrencyExchangeEntity';
  fromCurrencyId: Scalars['String'];
  toCurrencyId: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  fromAmt: Scalars['Float'];
  toAmt: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  commonStatus: CommonStatus;
};


export type DownloadLogEntity = CoreBaseEntity & {
  __typename?: 'DownloadLogEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  attachmentId?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileSize: Scalars['Float'];
  modulePath?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
};

export type EmailBlastArgs = {
  __typename?: 'EmailBlastArgs';
  senderName: Scalars['String'];
  senderEmail: Scalars['String'];
  recipients: Array<Scalars['String']>;
  subject: Scalars['String'];
  message: Scalars['String'];
  isMultiple: Scalars['Boolean'];
  ccEmail?: Maybe<Array<Scalars['String']>>;
  bccEmail?: Maybe<Array<Scalars['String']>>;
  categories?: Maybe<Array<Scalars['String']>>;
  attachments?: Maybe<Array<AttachmentData>>;
  replyTo?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['Float']>;
};

export type EmailBlastAttachment = {
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type EmailBlastLogEntity = CoreBaseEntity & {
  __typename?: 'EmailBlastLogEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  args?: Maybe<Scalars['JSON']>;
  recipientCount: Scalars['Float'];
  errorMsg?: Maybe<Scalars['String']>;
};

export type EntityContol = {
  noOfEntity?: Maybe<Scalars['Float']>;
  noofExtraEntity?: Maybe<Scalars['Float']>;
};

export type FilesOutput = {
  __typename?: 'FilesOutput';
  base64File?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
};

export type FromBankAccountEntity = {
  __typename?: 'FromBankAccountEntity';
  accountId: Scalars['String'];
  name: Scalars['String'];
  accountHolder: Scalars['String'];
  accountNo: Scalars['String'];
  branch: Scalars['String'];
  address: Scalars['JSON'];
  account: AccountEntity;
};

export type FromBankAccountInput = {
  accountHolder: Scalars['String'];
  accountNo: Scalars['String'];
  address: AddressInput;
  accountId: Scalars['String'];
  name: Scalars['String'];
  branch: Scalars['String'];
  ID?: Maybe<Scalars['String']>;
};

export type FromBankDetails = {
  __typename?: 'FromBankDetails';
  name?: Maybe<Scalars['String']>;
  acctHolder?: Maybe<Scalars['String']>;
  acctNo?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
};

export type FromBankDetailsInput = {
  name?: Maybe<Scalars['String']>;
  acctHolder?: Maybe<Scalars['String']>;
  acctNo?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
};

export type GetUpdateServiceRequestModel = {
  requestId: Scalars['String'];
  propertyId: Scalars['Float'];
};

export type HuaweiStorageOutput = {
  __typename?: 'HuaweiStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  Url: Scalars['String'];
  MediaType: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  PrivateUrl?: Maybe<Scalars['String']>;
};


export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessToken: Scalars['String'];
  user: UserEntity;
};

export type Mutation = {
  __typename?: 'Mutation';
  addApiCallToken: Scalars['Boolean'];
  updateAccountSettings: Scalars['Boolean'];
  insertDownloadLog: Scalars['Boolean'];
  markPostAsRead: Scalars['Boolean'];
  addNewsFeed: Scalars['Boolean'];
  updateNewsFeed: Scalars['Boolean'];
  updateFeedStatus: Scalars['Boolean'];
  updateSNumberFormat: Scalars['Boolean'];
  createRole: Scalars['Boolean'];
  editRole: Scalars['Boolean'];
  deleteRole: Scalars['Boolean'];
  assignUserRole: Scalars['Boolean'];
  createServiceRequest: Scalars['Boolean'];
  createRequestActivity: Scalars['Boolean'];
  updateServiceRequest: Scalars['Boolean'];
  deleteCloudRequestType: Scalars['Boolean'];
  deleteCloudPublicArea: Scalars['Boolean'];
  updateCloudRequestTypeName: Scalars['Boolean'];
  updateCloudPublicAreaName: Scalars['Boolean'];
  createCloudRequestType: Scalars['Boolean'];
  createCloudPublicArea: Scalars['Boolean'];
  updateCloudRequestType: Scalars['Boolean'];
  updateCloudPublicArea: Scalars['Boolean'];
  makeDefaultCloudRequestType: Scalars['Boolean'];
  makeDefaultCloudPublicArea: Scalars['Boolean'];
  updateUserStatus: Scalars['Boolean'];
  syncUser: Scalars['Boolean'];
};


export type MutationAddApiCallTokenArgs = {
  Token: Scalars['String'];
};


export type MutationUpdateAccountSettingsArgs = {
  settingValue: Scalars['String'];
  ID: Scalars['String'];
};


export type MutationInsertDownloadLogArgs = {
  attachmentId?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  fileSize: Scalars['Float'];
  fileName: Scalars['String'];
};


export type MutationMarkPostAsReadArgs = {
  input: NewsFeedReadStatusInputType;
};


export type MutationAddNewsFeedArgs = {
  input: NewsFeedInputType;
};


export type MutationUpdateNewsFeedArgs = {
  Input: NewsFeedInputType;
  NewsFeedId: Scalars['String'];
};


export type MutationUpdateFeedStatusArgs = {
  Status: Scalars['String'];
  NewsFeedId: Scalars['String'];
};


export type MutationUpdateSNumberFormatArgs = {
  formatID: Scalars['String'];
  numberFormat: Scalars['String'];
  numberLength: Scalars['Float'];
};


export type MutationCreateRoleArgs = {
  tenantAccessSecurity?: Maybe<Scalars['Boolean']>;
  permissionList: Array<Permission>;
  roleName: Scalars['String'];
};


export type MutationEditRoleArgs = {
  permissionList: Array<Permission>;
  roleName: Scalars['String'];
  roleId: Scalars['String'];
};


export type MutationDeleteRoleArgs = {
  roleId: Scalars['String'];
};


export type MutationAssignUserRoleArgs = {
  input: Array<UserRoleAssignmentInput>;
};


export type MutationCreateServiceRequestArgs = {
  SRInput: ServiceRequestInputModel;
};


export type MutationCreateRequestActivityArgs = {
  RequestActivityInput: RequestActivityInputModel;
};


export type MutationUpdateServiceRequestArgs = {
  UpdateServiceRequestModel: UpdateServiceRequestModel;
};


export type MutationDeleteCloudRequestTypeArgs = {
  requestTypeId: Scalars['String'];
};


export type MutationDeleteCloudPublicAreaArgs = {
  publicAreaId: Scalars['String'];
};


export type MutationUpdateCloudRequestTypeNameArgs = {
  name: Scalars['String'];
  requestTypeId: Scalars['String'];
};


export type MutationUpdateCloudPublicAreaNameArgs = {
  name: Scalars['String'];
  publicAreaId: Scalars['String'];
};


export type MutationCreateCloudRequestTypeArgs = {
  name: Scalars['String'];
};


export type MutationCreateCloudPublicAreaArgs = {
  name: Scalars['String'];
};


export type MutationUpdateCloudRequestTypeArgs = {
  requestTypeIds: Array<Scalars['String']>;
};


export type MutationUpdateCloudPublicAreaArgs = {
  publicAreaIds: Array<Scalars['String']>;
};


export type MutationMakeDefaultCloudRequestTypeArgs = {
  requestTypeId: Scalars['String'];
};


export type MutationMakeDefaultCloudPublicAreaArgs = {
  publicAreaId: Scalars['String'];
};


export type MutationUpdateUserStatusArgs = {
  activate: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type NewsFeedEntity = CoreBaseEntity & {
  __typename?: 'NewsFeedEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  feedTitle: Scalars['String'];
  feedContent: Scalars['String'];
  feedStatus?: Maybe<Scalars['String']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  accountId: Scalars['String'];
  hasExpiry?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  lPropertyId?: Maybe<Scalars['Float']>;
  isPostToAll?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['DateTime']>;
  commonStatus: CommonStatus;
  account: AccountEntity;
  newsFeedReadStatus?: Maybe<NewsFeedReadStatusEntity>;
  attachment?: Maybe<AttachmentEntity>;
  createdByUser?: Maybe<UserEntity>;
};

export type NewsFeedInputType = {
  id?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  feedTitle: Scalars['String'];
  feedContent: Scalars['String'];
  feedStatus: Scalars['String'];
  hasExpiry: Scalars['Boolean'];
  isPostToAll: Scalars['Boolean'];
  lPropertyId: Scalars['Float'];
  isTouched?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  attachment?: Maybe<Array<AttachmentModel>>;
};

export type NewsFeedReadStatusEntity = CoreBaseEntity & {
  __typename?: 'NewsFeedReadStatusEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  newsFeedId: Scalars['String'];
  commonStatus: CommonStatus;
  newsFeed?: Maybe<NewsFeedEntity>;
};

export type NewsFeedReadStatusInputType = {
  newsFeedId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
};

export type OnlineUserEntity = CoreBaseEntity & {
  __typename?: 'OnlineUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  userId: Scalars['String'];
  softwareId: Scalars['String'];
  accountId: Scalars['String'];
  entityId?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  lastLogin: Scalars['DateTime'];
  lastLogout?: Maybe<Scalars['DateTime']>;
  socketId?: Maybe<Scalars['String']>;
};

export type PackageEntity = CoreBaseEntity & {
  __typename?: 'PackageEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  softwareId: Scalars['String'];
  subscription: Array<SubscriptionEntity>;
  software: SoftwareEntity;
};

export type PackageInput = {
  ID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  softwareId?: Maybe<Scalars['String']>;
};

export enum Permission {
  TenantAppNewsListingView = 'TENANT_APP_NEWS_LISTING__________VIEW',
  TenantAppNewsView = 'TENANT_APP_NEWS_____________VIEW',
  TenantAppRentalContractListingView = 'TENANT_APP_RENTAL_CONTRACT_LISTING__________VIEW',
  TenantAppRentalContractView = 'TENANT_APP_RENTAL_CONTRACT_____________VIEW',
  TenantAppAccountView = 'TENANT_APP_ACCOUNT_____________VIEW',
  TenantAppAccountListingView = 'TENANT_APP_ACCOUNT_LISTING__________VIEW',
  TenantAppAccountListingPayment = 'TENANT_APP_ACCOUNT_LISTING__________PAYMENT',
  TenantAppBillPaymentView = 'TENANT_APP_BILL_PAYMENT_____________VIEW',
  TenantAppBillPaymentListingView = 'TENANT_APP_BILL_PAYMENT_LISTING__________VIEW',
  TenantAppBillPaymentListingPayment = 'TENANT_APP_BILL_PAYMENT_LISTING__________PAYMENT',
  TenantAppMeterUtilityListingView = 'TENANT_APP_METER_UTILITY_LISTING__________VIEW',
  TenantAppMeterUtilityView = 'TENANT_APP_METER_UTILITY_____________VIEW',
  TenantAppServiceRequestView = 'TENANT_APP_SERVICE_REQUEST_____________VIEW',
  TenantAppServiceRequestListingView = 'TENANT_APP_SERVICE_REQUEST_LISTING__________VIEW',
  TenantAppServiceRequestListingCreate = 'TENANT_APP_SERVICE_REQUEST_LISTING__________CREATE',
  TenantAppServiceRequestListingCancel = 'TENANT_APP_SERVICE_REQUEST_LISTING__________CANCEL',
  TenantAppServiceRequestListingDetailQuotationView = 'TENANT_APP_SERVICE_REQUEST_LISTING_DETAIL_QUOTATION____VIEW',
  TenantAppServiceRequestListingDetailQuotationListingView = 'TENANT_APP_SERVICE_REQUEST_LISTING_DETAIL_QUOTATION_LISTING_VIEW',
  TenantAppServiceRequestListingDetailQuotationListingUpdate = 'TENANT_APP_SERVICE_REQUEST_LISTING_DETAIL_QUOTATION_LISTING_UPDATE',
  TenantAppServiceRequestListingDetailActivityLogView = 'TENANT_APP_SERVICE_REQUEST_LISTING_DETAIL_ACTIVITY_LOG____VIEW',
  TenantAppServiceRequestListingDetailActivityLogListingView = 'TENANT_APP_SERVICE_REQUEST_LISTING_DETAIL_ACTIVITY_LOG_LISTING_VIEW',
  TenantAppTenantSalesView = 'TENANT_APP_TENANT_SALES_____________VIEW',
  TenantAppTenantSalesListingView = 'TENANT_APP_TENANT_SALES_LISTING__________VIEW',
  TenantAppTenantSalesListingCreate = 'TENANT_APP_TENANT_SALES_LISTING__________CREATE',
  TenantAppTenantSalesListingSubmissionSubmit = 'TENANT_APP_TENANT_SALES_LISTING_SUBMISSION_______SUBMIT',
  TenantAppTenantSalesListingSubmissionDraft = 'TENANT_APP_TENANT_SALES_LISTING_SUBMISSION_______DRAFT',
  TenantAppTenantSalesListingSubmissionAddPos = 'TENANT_APP_TENANT_SALES_LISTING_SUBMISSION_______ADD_POS',
  TenantAppUserManagementView = 'TENANT_APP_USER_MANAGEMENT_____________VIEW',
  TenantAppUserManagementListingView = 'TENANT_APP_USER_MANAGEMENT_LISTING__________VIEW',
  TenantAppUserManagementListingUpdate = 'TENANT_APP_USER_MANAGEMENT_LISTING__________UPDATE',
  TenantAppUserManagementListingCreate = 'TENANT_APP_USER_MANAGEMENT_LISTING__________CREATE',
  WorkdeskNewsView = 'WORKDESK_NEWS_____________VIEW',
  WorkdeskNewsListingView = 'WORKDESK_NEWS_LISTING__________VIEW',
  WorkdeskNewsListingUpdate = 'WORKDESK_NEWS_LISTING__________UPDATE',
  WorkdeskNewsListingDelete = 'WORKDESK_NEWS_LISTING__________DELETE',
  WorkdeskNewsListingUpdateStatus = 'WORKDESK_NEWS_LISTING__________UPDATE_STATUS',
  WorkdeskNewsListingCreate = 'WORKDESK_NEWS_LISTING__________CREATE',
  WorkdeskNewsListingDetailDraft = 'WORKDESK_NEWS_LISTING_DETAIL_______DRAFT',
  WorkdeskNewsListingDetailPublish = 'WORKDESK_NEWS_LISTING_DETAIL_______PUBLISH',
  WorkdeskNewsListingDetailPostToAll = 'WORKDESK_NEWS_LISTING_DETAIL_______POST_TO_ALL',
  WorkdeskTodoView = 'WORKDESK_TODO_____________VIEW',
  WorkdeskNotificationView = 'WORKDESK_NOTIFICATION_____________VIEW',
  WorkdeskTodoListingView = 'WORKDESK_TODO_LISTING__________VIEW',
  WorkdeskNotificationListingView = 'WORKDESK_NOTIFICATION_LISTING__________VIEW',
  WorkdeskBusinessInsightView = 'WORKDESK_BUSINESS_INSIGHT_____________VIEW',
  WorkdeskBusinessInsightAgeingAnalysisView = 'WORKDESK_BUSINESS_INSIGHT_AGEING_ANALYSIS__________VIEW',
  WorkdeskBusinessInsightBookingStatisticsView = 'WORKDESK_BUSINESS_INSIGHT_BOOKING_STATISTICS__________VIEW',
  WorkdeskBusinessInsightOccupancyStatisticsView = 'WORKDESK_BUSINESS_INSIGHT_OCCUPANCY_STATISTICS__________VIEW',
  WorkdeskBusinessInsightContractOpportunityView = 'WORKDESK_BUSINESS_INSIGHT_CONTRACT_OPPORTUNITY__________VIEW',
  WorkdeskBusinessInsightNext_12MonthsOccupancyProjectionView = 'WORKDESK_BUSINESS_INSIGHT_NEXT_12_MONTHS_OCCUPANCY_PROJECTION__________VIEW',
  WorkdeskBusinessInsightRentalIncomeProjectionView = 'WORKDESK_BUSINESS_INSIGHT_RENTAL_INCOME_PROJECTION__________VIEW',
  WorkdeskBusinessInsightTenantSalesCollectionAnalysisView = 'WORKDESK_BUSINESS_INSIGHT_TENANT_SALES_COLLECTION_ANALYSIS__________VIEW',
  WorkdeskBusinessInsightTop_10RentalContributorView = 'WORKDESK_BUSINESS_INSIGHT_TOP_10_RENTAL_CONTRIBUTOR__________VIEW',
  WorkdeskBusinessInsightTop_10OutstandingView = 'WORKDESK_BUSINESS_INSIGHT_TOP_10_OUTSTANDING__________VIEW',
  WorkdeskBusinessInsightActiveContractReportView = 'WORKDESK_BUSINESS_INSIGHT_ACTIVE_CONTRACT_REPORT__________VIEW',
  WorkdeskBusinessInsightExpiringContractReportView = 'WORKDESK_BUSINESS_INSIGHT_EXPIRING_CONTRACT_REPORT__________VIEW',
  WorkdeskBusinessInsightDailySalesSubmissionReportView = 'WORKDESK_BUSINESS_INSIGHT_DAILY_SALES_SUBMISSION_REPORT__________VIEW',
  WorkdeskBusinessInsightServiceRequestReportView = 'WORKDESK_BUSINESS_INSIGHT_SERVICE_REQUEST_REPORT__________VIEW',
  WorkdeskBusinessInsightServiceRequestReportBiView = 'WORKDESK_BUSINESS_INSIGHT_SERVICE_REQUEST_REPORT_BI__________VIEW',
  WorkdeskBusinessTenantPaymentTransactionsView = 'WORKDESK_BUSINESS_INSIGHT_TENANT_PAYMENT_TRANSACTIONS__________VIEW',
  OperationNewsView = 'OPERATION_NEWS_____________VIEW',
  OperationNewsListingView = 'OPERATION_NEWS_LISTING__________VIEW',
  OperationNewsListingUpdate = 'OPERATION_NEWS_LISTING__________UPDATE',
  OperationNewsListingDelete = 'OPERATION_NEWS_LISTING__________DELETE',
  OperationNewsListingUpdateStatus = 'OPERATION_NEWS_LISTING__________UPDATE_STATUS',
  OperationNewsListingCreate = 'OPERATION_NEWS_LISTING__________CREATE',
  OperationNewsListingDetailDraft = 'OPERATION_NEWS_LISTING_DETAIL_______DRAFT',
  OperationNewsListingDetailPublish = 'OPERATION_NEWS_LISTING_DETAIL_______PUBLISH',
  OperationNewsListingDetailPostToAll = 'OPERATION_NEWS_LISTING_DETAIL_______POST_TO_ALL',
  OperationMeterUtilityView = 'OPERATION_METER_UTILITY_____________VIEW',
  OperationMeterUtilityMeterTypeListingView = 'OPERATION_METER_UTILITY_METER_TYPE_LISTING_______VIEW',
  OperationMeterUtilityMeterTypeSubMeterView = 'OPERATION_METER_UTILITY_METER_TYPE_SUB_METER_______VIEW',
  OperationMeterUtilityMeterTypeMasterMeterView = 'OPERATION_METER_UTILITY_METER_TYPE_MASTER_METER_______VIEW',
  OperationMeterUtilityMeterTypeSubMeterListingView = 'OPERATION_METER_UTILITY_METER_TYPE_SUB_METER_LISTING____VIEW',
  OperationMeterUtilityMeterTypeMasterMeterListingView = 'OPERATION_METER_UTILITY_METER_TYPE_MASTER_METER_LISTING____VIEW',
  OperationMeterUtilityMeterTypeSubMeterListingMeterReadingCreate = 'OPERATION_METER_UTILITY_METER_TYPE_SUB_METER_LISTING_METER_READING_CREATE',
  OperationMeterUtilityMeterTypeMasterMeterListingMeterReadingCreate = 'OPERATION_METER_UTILITY_METER_TYPE_MASTER_METER_LISTING_METER_READING_CREATE',
  OperationServiceRequestView = 'OPERATION_SERVICE_REQUEST_____________VIEW',
  OperationServiceRequestListingView = 'OPERATION_SERVICE_REQUEST_LISTING__________VIEW',
  OperationServiceRequestListingCreate = 'OPERATION_SERVICE_REQUEST_LISTING__________CREATE',
  OperationServiceRequestListingDetailUpdate = 'OPERATION_SERVICE_REQUEST_LISTING_DETAIL_______UPDATE',
  OperationServiceRequestListingDetailQuotationView = 'OPERATION_SERVICE_REQUEST_LISTING_DETAIL_QUOTATION____VIEW',
  OperationServiceRequestListingDetailActivityLogView = 'OPERATION_SERVICE_REQUEST_LISTING_DETAIL_ACTIVITY_LOG____VIEW',
  OperationServiceRequestListingDetailQuotationListingView = 'OPERATION_SERVICE_REQUEST_LISTING_DETAIL_QUOTATION_LISTING_VIEW',
  OperationServiceRequestListingDetailActivityLogListingView = 'OPERATION_SERVICE_REQUEST_LISTING_DETAIL_ACTIVITY_LOG_LISTING_VIEW',
  OperationServiceRequestListingDetailActivityLogListingCreate = 'OPERATION_SERVICE_REQUEST_LISTING_DETAIL_ACTIVITY_LOG_LISTING_CREATE',
  OperationTenantSalesView = 'OPERATION_TENANT_SALES_____________VIEW',
  OperationTenantSalesSubmissionView = 'OPERATION_TENANT_SALES_SUBMISSION__________VIEW',
  OperationTenantSalesCollectionRecordView = 'OPERATION_TENANT_SALES_COLLECTION_RECORD__________VIEW',
  OperationTenantSalesSubmissionListingView = 'OPERATION_TENANT_SALES_SUBMISSION_LISTING_______VIEW',
  OperationTenantSalesSubmissionListingApprove = 'OPERATION_TENANT_SALES_SUBMISSION_LISTING_______APPROVE',
  OperationTenantSalesSubmissionListingCreate = 'OPERATION_TENANT_SALES_SUBMISSION_LISTING_______CREATE',
  OperationTenantSalesSubmissionListingReject = 'OPERATION_TENANT_SALES_SUBMISSION_LISTING_______REJECT',
  OperationTenantSalesSubmissionListingSubmissionSubmit = 'OPERATION_TENANT_SALES_SUBMISSION_LISTING_SUBMISSION____SUBMIT',
  OperationTenantSalesSubmissionListingSubmissionAddPos = 'OPERATION_TENANT_SALES_SUBMISSION_LISTING_SUBMISSION____ADD_POS',
  OperationTenantSalesCollectionRecordListingView = 'OPERATION_TENANT_SALES_COLLECTION_RECORD_LISTING_______VIEW',
  OperationRoutineInspectionView = 'OPERATION_ROUTINE_INSPECTION_____________VIEW',
  OperationRoutineInspectionListingView = 'OPERATION_ROUTINE_INSPECTION_LISTING__________VIEW',
  OperationRoutineInspectionListingCreate = 'OPERATION_ROUTINE_INSPECTION_LISTING__________CREATE',
  SystemAdminAccessSecurityView = 'SYSTEM_ADMIN_ACCESS_SECURITY_____________VIEW',
  SystemAdminAccessSecurityUserView = 'SYSTEM_ADMIN_ACCESS_SECURITY_USER__________VIEW',
  SystemAdminAccessSecurityRoleView = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE__________VIEW',
  SystemAdminAccessSecurityRoleAssignmentView = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE_ASSIGNMENT__________VIEW',
  SystemAdminAccessSecurityUserListingView = 'SYSTEM_ADMIN_ACCESS_SECURITY_USER_LISTING_______VIEW',
  SystemAdminAccessSecurityUserListingUpdateStatus = 'SYSTEM_ADMIN_ACCESS_SECURITY_USER_LISTING_______UPDATE_STATUS',
  SystemAdminAccessSecurityUserListingSyncUser = 'SYSTEM_ADMIN_ACCESS_SECURITY_USER_LISTING_______SYNC_USER',
  SystemAdminAccessSecurityRoleListingView = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE_LISTING_______VIEW',
  SystemAdminAccessSecurityRoleListingUpdate = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE_LISTING_______UPDATE',
  SystemAdminAccessSecurityRoleListingDelete = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE_LISTING_______DELETE',
  SystemAdminAccessSecurityRoleListingCreate = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE_LISTING_______CREATE',
  SystemAdminAccessSecurityRoleAssignmentDetailSubmit = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE_ASSIGNMENT_DETAIL_______SUBMIT',
  SystemAdminTenantAccessSecurityView = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_____________VIEW',
  SystemAdminTenantAccessSecurityUserView = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_USER__________VIEW',
  SystemAdminTenantAccessSecurityUserListingView = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_USER_LISTING_______VIEW',
  SystemAdminTenantAccessSecurityRoleView = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_ROLE__________VIEW',
  SystemAdminTenantAccessSecurityRoleListingView = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_ROLE_LISTING_______VIEW',
  SystemAdminTenantAccessSecurityRoleListingUpdate = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_ROLE_LISTING_______UPDATE',
  SystemAdminTenantAccessSecurityRoleListingDelete = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_ROLE_LISTING_______DELETE',
  SystemAdminTenantAccessSecurityRoleListingCreate = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_ROLE_LISTING_______CREATE',
  SystemAdminDocumentNumberView = 'SYSTEM_ADMIN_DOCUMENT_NUMBER_____________VIEW',
  SystemAdminDocumentNumberListingView = 'SYSTEM_ADMIN_DOCUMENT_NUMBER_LISTING__________VIEW',
  SystemAdminDocumentNumberListingDetailUpdate = 'SYSTEM_ADMIN_DOCUMENT_NUMBER_LISTING_DETAIL_______UPDATE',
  SalesPropertyGalleryView = 'SALES_PROPERTY_GALLERY_____________VIEW',
  SalesOpportunityView = 'SALES_OPPORTUNITY_____________VIEW',
  SalesOpportunityListingView = 'SALES_OPPORTUNITY_LISTING__________VIEW',
  SalesOpportunityListingCreate = 'SALES_OPPORTUNITY_LISTING__________CREATE',
  SalesOpportunityListingDetailView = 'SALES_OPPORTUNITY_LISTING_DETAIL_______VIEW',
  SalesOpportunityListingDetailUpdate = 'SALES_OPPORTUNITY_LISTING_DETAIL_______UPDATE',
  SalesOpportunityListingActivityLogView = 'SALES_OPPORTUNITY_LISTING_ACTIVITY_LOG_______VIEW',
  SalesOpportunityListingLetterOfOfferView = 'SALES_OPPORTUNITY_LISTING_LETTER_OF_OFFER_______VIEW',
  SalesOpportunityListingBookingView = 'SALES_OPPORTUNITY_LISTING_BOOKING_______VIEW',
  SalesOpportunityListingOpportunityAssignmentView = 'SALES_OPPORTUNITY_LISTING_OPPORTUNITY_ASSIGNMENT_______VIEW',
  SalesOpportunityListingActivityLogListingCreate = 'SALES_OPPORTUNITY_LISTING_ACTIVITY_LOG_LISTING____CREATE',
  SalesOpportunityListingActivityLogListingView = 'SALES_OPPORTUNITY_LISTING_ACTIVITY_LOG_LISTING____VIEW',
  SalesOpportunityListingBookingListingView = 'SALES_OPPORTUNITY_LISTING_BOOKING_LISTING____VIEW',
  SalesOpportunityListingBookingListingCreate = 'SALES_OPPORTUNITY_LISTING_BOOKING_LISTING____CREATE',
  SalesOpportunityListingOpportunityAssignmentListingView = 'SALES_OPPORTUNITY_LISTING_OPPORTUNITY_ASSIGNMENT_LISTING____VIEW',
  SalesOpportunityListingOpportunityAssignmentListingCreate = 'SALES_OPPORTUNITY_LISTING_OPPORTUNITY_ASSIGNMENT_LISTING____CREATE',
  SalesOpportunityListingOpportunityAssignmentListingDelete = 'SALES_OPPORTUNITY_LISTING_OPPORTUNITY_ASSIGNMENT_LISTING____DELETE',
  SalesBookingView = 'SALES_BOOKING_____________VIEW',
  SalesBookingListingView = 'SALES_BOOKING_LISTING__________VIEW',
  SalesBookingListingCreate = 'SALES_BOOKING_LISTING__________CREATE',
  SalesRentalContractView = 'SALES_RENTAL_CONTRACT_____________VIEW',
  SalesRentalContractListingView = 'SALES_RENTAL_CONTRACT_LISTING__________VIEW'
}

export type PermissionDetail = {
  __typename?: 'PermissionDetail';
  title: Scalars['String'];
  description: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  permissionId?: Maybe<Scalars['Float']>;
  child?: Maybe<Array<PermissionDetail>>;
};

export type PermissionRoleEntity = CoreBaseEntity & {
  __typename?: 'PermissionRoleEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  roleId: Scalars['String'];
  permissionId: Scalars['Float'];
  role: RoleEntity;
  permissionCode: Scalars['String'];
};

export type PostcodeEntity = CoreBaseEntity & {
  __typename?: 'PostcodeEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  postcode: Scalars['String'];
  cityId: Scalars['String'];
  commonStatus: CommonStatus;
  city: CityEntity;
};

export type PostcodeInput = {
  postcode?: Maybe<Scalars['String']>;
  cityID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  getAccountSetting?: Maybe<SAccountSettings>;
  AttachmentByRefIdAndRefTable?: Maybe<Array<AttachmentEntity>>;
  AttachmentDownload?: Maybe<FilesOutput>;
  getAnnouncementsByPropertyId?: Maybe<Array<NewsFeedEntity>>;
  getAnnouncementById: NewsFeedEntity;
  getNumberFormat?: Maybe<Array<SNumberFormat>>;
  getNumberFormatById?: Maybe<SNumberFormat>;
  getPermissionList: Array<PermissionDetail>;
  getRoleByAccountId: Array<RoleEntity>;
  getTotalPermissionCount: Scalars['Float'];
  getRoleById: RoleEntity;
  getLastestRoleAssignmentDate?: Maybe<Scalars['DateTime']>;
  getRoleList: Array<RoleEntity>;
  requestActivityById?: Maybe<RequestActivity>;
  serviceRequestSummaryByPropertyId?: Maybe<ServiceRequestSummary>;
  serviceRequestById?: Maybe<ServiceRequest>;
  GetServiceRequestInputData: CreateServiceRequestCriteria;
  filteredServiceRequestByPropertyId?: Maybe<Array<ServiceRequest>>;
  getServiceRequestActivityInput: ServiceRequestActivityCriteria;
  getServiceRequestUpdateInput: ServiceRequestUpdateCriteria;
  getServiceRequestReport: ServiceRequest;
  getCloudRequestType: Array<RequestType>;
  getCloudPublicArea: Array<RequestPublicArea>;
  getServiceRequestMasterDataSummary: ServiceRequestMasterDataSummary;
  getDWMServiceRequestReport?: Maybe<ServiceRequestDailyWeeklyMonthlyReport>;
  getTenantPaymentTransactionsByPropertyId: Array<TenantPaymentTransactionsOutput>;
  selectUserAccSoftwareByUserId?: Maybe<Array<UserAccSoftwareEntity>>;
  getTenantRegisteredCount: Scalars['Float'];
  getTenantRegistered: Array<TenantListOutput>;
  selectUsersById?: Maybe<UserEntity>;
  getUserRoleByUserId?: Maybe<Array<RoleEntity>>;
  getTenantUserRoleByUserId?: Maybe<Array<TenantUserRoleOutput>>;
  getUserById?: Maybe<UserEntity>;
  getUserCountSummary: UserCountSummary;
  getTenantUserCountSummary: UserCountSummary;
  getMallUsersByAccount: Array<UserEntity>;
  getTenantUsersByAccount: Array<UserEntity>;
};


export type QueryGetAccountSettingArgs = {
  settingKey: Scalars['String'];
};


export type QueryAttachmentByRefIdAndRefTableArgs = {
  input: AttachmentByRefIdAndRefTableInput;
};


export type QueryAttachmentDownloadArgs = {
  url: Scalars['String'];
};


export type QueryGetAnnouncementsByPropertyIdArgs = {
  IsFindLatestPostDate?: Maybe<Scalars['Boolean']>;
  PropertyId: Scalars['Float'];
};


export type QueryGetAnnouncementByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetNumberFormatByIdArgs = {
  formatID: Scalars['String'];
};


export type QueryGetPermissionListArgs = {
  softwares?: Maybe<Array<Software>>;
};


export type QueryGetRoleByAccountIdArgs = {
  tenantAccessSecurity?: Maybe<Scalars['Boolean']>;
  accountId?: Maybe<Scalars['String']>;
};


export type QueryGetTotalPermissionCountArgs = {
  softwares?: Maybe<Array<Software>>;
};


export type QueryGetRoleByIdArgs = {
  roleId: Scalars['String'];
};


export type QueryGetLastestRoleAssignmentDateArgs = {
  tenantAccessSecurity?: Maybe<Scalars['Boolean']>;
};


export type QueryRequestActivityByIdArgs = {
  ActivityId: Scalars['String'];
};


export type QueryServiceRequestSummaryByPropertyIdArgs = {
  PropertyId: Scalars['Float'];
};


export type QueryServiceRequestByIdArgs = {
  RequestId: Scalars['String'];
};


export type QueryGetServiceRequestInputDataArgs = {
  PropertyId: Scalars['Float'];
};


export type QueryFilteredServiceRequestByPropertyIdArgs = {
  LastAssignTo: Scalars['String'];
  RequestType: Scalars['String'];
  OrderBy: Scalars['String'];
  RequestStatus: Array<Scalars['String']>;
  PropertyId: Scalars['Float'];
};


export type QueryGetServiceRequestActivityInputArgs = {
  serviceRequestId: Scalars['String'];
  lPropertyId: Scalars['Float'];
};


export type QueryGetServiceRequestUpdateInputArgs = {
  input: GetUpdateServiceRequestModel;
};


export type QueryGetServiceRequestReportArgs = {
  propertyId: Scalars['Float'];
};


export type QueryGetDwmServiceRequestReportArgs = {
  asOfDate: Scalars['DateTime'];
  reqTypeId: Scalars['String'];
  lPropId: Scalars['Float'];
  accountId: Scalars['String'];
};


export type QueryGetTenantPaymentTransactionsByPropertyIdArgs = {
  PropertyId: Scalars['Float'];
};


export type QueryGetUserRoleByUserIdArgs = {
  userId?: Maybe<Scalars['String']>;
};


export type QueryGetTenantUserRoleByUserIdArgs = {
  userId?: Maybe<Scalars['String']>;
};


export type QueryGetUserByIdArgs = {
  userId: Scalars['String'];
};


export type QueryGetMallUsersByAccountArgs = {
  activeUserOnly?: Maybe<Scalars['Boolean']>;
};

export type Recipient = {
  __typename?: 'Recipient';
  name?: Maybe<Scalars['String']>;
  email: Scalars['String'];
};

export type ReportLogEntity = {
  __typename?: 'ReportLogEntity';
  ID: Scalars['String'];
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  reportName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  requestDate?: Maybe<Scalars['DateTime']>;
};

export type ReportLogInput = {
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  reportName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type RequestActivity = CoreBaseEntity & {
  __typename?: 'RequestActivity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  assignId: Scalars['String'];
  tenantView: Scalars['Boolean'];
  remark?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  requestId: Scalars['String'];
  request: ServiceRequest;
  requestEstimation?: Maybe<RequestEstimation>;
  requestFollowUp?: Maybe<RequestFollowUp>;
  requestQuotation?: Maybe<RequestQuotation>;
  assignTo: UserEntity;
  attachment?: Maybe<Array<AttachmentEntity>>;
  numberOfAttachment?: Maybe<Scalars['Float']>;
  getLatestTwoRequestQuotation?: Maybe<RequestQuotation>;
  requestStatus?: Maybe<Scalars['String']>;
};

export type RequestActivityInputModel = {
  requestId: Scalars['String'];
  activityCategory: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  tenantView: Scalars['Boolean'];
  attachment?: Maybe<Array<Scalars['Upload']>>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  durationDay?: Maybe<Scalars['Float']>;
  durationHour?: Maybe<Scalars['Float']>;
  contactName?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  appointmentDate?: Maybe<Scalars['DateTime']>;
  followUpDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  assignTo?: Maybe<Scalars['String']>;
};

export type RequestEstimation = CoreBaseEntity & {
  __typename?: 'RequestEstimation';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  processDate?: Maybe<Scalars['DateTime']>;
  completeDate?: Maybe<Scalars['DateTime']>;
  durationDay?: Maybe<Scalars['Float']>;
  durationHour?: Maybe<Scalars['Float']>;
  commonStatus: CommonStatus;
  requestActivityId: Scalars['String'];
  requestActivity: RequestActivity;
  attachment?: Maybe<Array<AttachmentEntity>>;
  numberOfAttachment?: Maybe<Scalars['Float']>;
};

export type RequestFollowUp = CoreBaseEntity & {
  __typename?: 'RequestFollowUp';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  activityDate: Scalars['DateTime'];
  appointDate?: Maybe<Scalars['DateTime']>;
  commonStatus: CommonStatus;
  requestActivityId: Scalars['String'];
  requestActivity: RequestActivity;
  attachment?: Maybe<Array<AttachmentEntity>>;
  numberOfAttachment?: Maybe<Scalars['Float']>;
};

export type RequestLog = CoreBaseEntity & {
  __typename?: 'RequestLog';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  logTenant?: Maybe<Scalars['String']>;
  logMall?: Maybe<Scalars['String']>;
  isShow: Scalars['Boolean'];
  requestId: Scalars['String'];
  requestActivityId: Scalars['String'];
  commonStatus: CommonStatus;
  requestStatus: Scalars['String'];
  requestActivity?: Maybe<RequestActivity>;
  request: ServiceRequest;
};


export type RequestLogRequestActivityArgs = {
  TenantView?: Maybe<Scalars['Boolean']>;
};

export type RequestPublicArea = CoreBaseEntity & {
  __typename?: 'RequestPublicArea';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seqNo: Scalars['Float'];
  requestOfPublicArea: Array<ServiceRequest>;
};

export type RequestQuotation = CoreBaseEntity & {
  __typename?: 'RequestQuotation';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  isProceed?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
  operatorName?: Maybe<Scalars['String']>;
  operatorContactNo?: Maybe<Scalars['String']>;
  operatorEmail?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  requestActivityId: Scalars['String'];
  requestActivity: RequestActivity;
  attachment?: Maybe<AttachmentEntity>;
  numberOfAttachment?: Maybe<Scalars['Float']>;
};

export type RequestType = CoreBaseEntity & {
  __typename?: 'RequestType';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seqNo: Scalars['Float'];
  requestOfType: Array<ServiceRequest>;
};

export type RoleEntity = CoreBaseEntity & {
  __typename?: 'RoleEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  name: Scalars['String'];
  account: AccountEntity;
  software?: Maybe<SoftwareEntity>;
  permissions?: Maybe<Array<PermissionRoleEntity>>;
  totalPermission: Scalars['Float'];
  users?: Maybe<Array<UserEntity>>;
  roleUsers?: Maybe<Array<RoleUserEntity>>;
};


export type RoleEntityRoleUsersArgs = {
  isByUserId?: Maybe<Scalars['Boolean']>;
};

export type RoleUserEntity = CoreBaseEntity & {
  __typename?: 'RoleUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  entityId: Scalars['String'];
  roleId: Scalars['String'];
  userId: Scalars['String'];
  account: AccountEntity;
  role: RoleEntity;
  user: UserEntity;
};

export type SAccountSettings = CoreBaseEntity & {
  __typename?: 'SAccountSettings';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  settingKey: Scalars['String'];
  settingValue: Scalars['String'];
  accountId: Scalars['String'];
  account: AccountEntity;
};

export type SApiGateway = CoreBaseEntity & {
  __typename?: 'SApiGateway';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  apiGatewayUrl?: Maybe<Scalars['String']>;
  tokenValidity?: Maybe<Scalars['String']>;
  logoId?: Maybe<Scalars['String']>;
  apiCallToken?: Maybe<Scalars['String']>;
  adminUserId?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  accountId?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  account?: Maybe<AccountEntity>;
  software?: Maybe<SoftwareEntity>;
};

export type SGatewayUpdates = CoreBaseEntity & {
  __typename?: 'SGatewayUpdates';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  version: Scalars['String'];
  md5: Scalars['String'];
  hasSqlUpdate: Scalars['Boolean'];
  url: Scalars['String'];
  verifySql?: Maybe<Scalars['String']>;
  sql?: Maybe<Scalars['String']>;
};

export type SNumberFormat = CoreBaseEntity & {
  __typename?: 'SNumberFormat';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  numberTypeId: Scalars['String'];
  numberFormat: Scalars['String'];
  numberLength: Scalars['Float'];
  commonStatus: CommonStatus;
  account: AccountEntity;
  numberType: SNumberType;
  sRunningNumberSetups: Array<SRunningNumberSetup>;
  prefixCode: Scalars['String'];
};

export type SNumberType = CoreBaseEntity & {
  __typename?: 'SNumberType';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  numberCode: Scalars['String'];
  numberName: Scalars['String'];
  commonStatus: CommonStatus;
  sNumberFormats: Array<SNumberFormat>;
};

export type SPaymentTransaction = CoreBaseEntity & {
  __typename?: 'SPaymentTransaction';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  transactionDate?: Maybe<Scalars['DateTime']>;
  amount: Scalars['Float'];
  paymentMethod?: Maybe<Scalars['String']>;
  referenceNo: Scalars['String'];
  status: Scalars['String'];
  response?: Maybe<Scalars['JSON']>;
  paymentProvider?: Maybe<Scalars['String']>;
  isPendingIntegration: Scalars['Boolean'];
  noOfRetry: Scalars['Float'];
  integrationError?: Maybe<Scalars['String']>;
  lDebtorId?: Maybe<Scalars['Float']>;
  account: AccountEntity;
  createdUser: UserEntity;
  isDeposit?: Maybe<Scalars['Boolean']>;
  transactionDetails?: Maybe<Array<SPaymentTransactionDetails>>;
};

export type SPaymentTransactionDetails = CoreBaseEntity & {
  __typename?: 'SPaymentTransactionDetails';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  sPaymentTransactionId: Scalars['String'];
  amount: Scalars['Float'];
  lBillId: Scalars['Float'];
  lDocumentNo: Scalars['String'];
  lBillItemName: Scalars['String'];
  lDocumentAmt: Scalars['Float'];
  lBalanceAmt?: Maybe<Scalars['Float']>;
  lChargeAmt?: Maybe<Scalars['Float']>;
  lTaxAmt?: Maybe<Scalars['Float']>;
  otherInfo?: Maybe<Scalars['JSON']>;
  transaction: SPaymentTransaction;
};

export type SRunningNumberSetup = CoreBaseEntity & {
  __typename?: 'SRunningNumberSetup';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  numberFormatId: Scalars['String'];
  accountId: Scalars['String'];
  nextNumber: Scalars['Float'];
  numberFormat: SNumberFormat;
};

export type ServiceDetail = CoreBaseEntity & {
  __typename?: 'ServiceDetail';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  request: ServiceRequest;
  attachment?: Maybe<AttachmentEntity>;
};

export type ServiceDetailModel = {
  message?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['Upload']>;
  isAttachment: Scalars['Boolean'];
};

export type ServiceDetailsMediaCount = {
  __typename?: 'ServiceDetailsMediaCount';
  ID?: Maybe<Scalars['String']>;
  textMediaCount?: Maybe<Scalars['Float']>;
  audioMediaCount?: Maybe<Scalars['Float']>;
  imageMediaCount?: Maybe<Scalars['Float']>;
  videoMediaCount?: Maybe<Scalars['Float']>;
};

export type ServiceRequest = CoreBaseEntity & {
  __typename?: 'ServiceRequest';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  lPropertyId: Scalars['Float'];
  lDebtorId?: Maybe<Scalars['Float']>;
  lUnitId?: Maybe<Scalars['Float']>;
  lastAssignId?: Maybe<Scalars['String']>;
  requestNo: Scalars['String'];
  requestStatus: Scalars['String'];
  publicAreaId?: Maybe<Scalars['String']>;
  requesterName: Scalars['String'];
  requesterContact?: Maybe<Scalars['String']>;
  requestTypeId?: Maybe<Scalars['String']>;
  requestTitle?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  accountId: Scalars['String'];
  isCancelled: Scalars['Boolean'];
  requestActivities?: Maybe<Array<RequestActivity>>;
  requestLogs: Array<RequestLog>;
  serviceDetails: Array<ServiceDetail>;
  account: AccountEntity;
  requestTypeData?: Maybe<RequestType>;
  publicAreaData?: Maybe<RequestPublicArea>;
  serviceDetailsMediaCount?: Maybe<ServiceDetailsMediaCount>;
  serviceRequestQuotationCount?: Maybe<ServiceRequestQuotationCount>;
  unitNo?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  createdUser?: Maybe<UserEntity>;
  lastAssignTo?: Maybe<Scalars['String']>;
  getLatestTwoRequestQuotation?: Maybe<Array<RequestQuotation>>;
  nextFollowUpDate?: Maybe<Scalars['DateTime']>;
  ServiceRequestReport?: Maybe<Array<BusinessInsightOutput>>;
};


export type ServiceRequestRequestLogsArgs = {
  IsShow?: Maybe<Scalars['Boolean']>;
};

export type ServiceRequestActivityCriteria = {
  __typename?: 'ServiceRequestActivityCriteria';
  srStatus: Array<Scalars['String']>;
  srActivityCategory: Array<Scalars['String']>;
  assignTo: Array<AssignTo>;
  requestCreatedDate: Scalars['DateTime'];
};

export type ServiceRequestCriteria = {
  __typename?: 'ServiceRequestCriteria';
  serviceRequestAreaType: Array<Scalars['String']>;
  publicArea?: Maybe<Array<Scalars['String']>>;
  units?: Maybe<Array<UnitModel>>;
};

export type ServiceRequestDailyWeeklyMonthlyReport = {
  __typename?: 'ServiceRequestDailyWeeklyMonthlyReport';
  daily?: Maybe<Array<BusinessInsightOutput>>;
  weekly?: Maybe<Array<BusinessInsightOutput>>;
  monthly?: Maybe<Array<BusinessInsightOutput>>;
};

export type ServiceRequestInputModel = {
  accountId?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['Float']>;
  publicAreaDesc?: Maybe<Scalars['String']>;
  debotrId?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['Float']>;
  serviceDetail?: Maybe<Array<ServiceDetailModel>>;
  requestType: Scalars['String'];
  title: Scalars['String'];
  requestBy: Scalars['String'];
  requestByContactNo?: Maybe<Scalars['String']>;
  assignedToId?: Maybe<Scalars['String']>;
};

export type ServiceRequestMasterDataSummary = {
  __typename?: 'ServiceRequestMasterDataSummary';
  noOfPublicArea: Scalars['Float'];
  noOfRequestType: Scalars['Float'];
};

export type ServiceRequestQuotationCount = {
  __typename?: 'ServiceRequestQuotationCount';
  ID: Scalars['String'];
  quotationCount: Scalars['Float'];
};

export type ServiceRequestSummary = {
  __typename?: 'ServiceRequestSummary';
  lPropertyId?: Maybe<Scalars['Float']>;
  reportedCount?: Maybe<Scalars['Float']>;
  inProgressCount?: Maybe<Scalars['Float']>;
  resolvedCount?: Maybe<Scalars['Float']>;
  closedCount?: Maybe<Scalars['Float']>;
};

export type ServiceRequestUpdateCriteria = {
  __typename?: 'ServiceRequestUpdateCriteria';
  serviceRequestAreaType: Array<Scalars['String']>;
  publicArea?: Maybe<Array<Scalars['String']>>;
  units?: Maybe<Array<UnitModel>>;
  requestType?: Maybe<Array<Scalars['String']>>;
};

export enum Software {
  TenantApp = 'TenantApp',
  LeaseWorkdesk = 'LeaseWorkdesk',
  LeaseOperation = 'LeaseOperation',
  LeaseSales = 'LeaseSales',
  SystemAdmin = 'SystemAdmin'
}

export type SoftwareDelInput = {
  ID: Scalars['String'];
};

export type SoftwareEntity = CoreBaseEntity & {
  __typename?: 'SoftwareEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  supportEmail?: Maybe<Scalars['String']>;
  serviceHostUrl?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  softwareAccount: UserAccSoftwareEntity;
  subscription: Array<SubscriptionEntity>;
  package: Array<PackageEntity>;
  termsConditions: Array<TermsConditionsEntity>;
  roles?: Maybe<Array<RoleEntity>>;
};

export type SoftwareInfo = {
  name: Scalars['String'];
  ID: Scalars['String'];
};

export type SoftwareInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  serviceHostUrl?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<PackageInput>>;
};

export type SoftwareUpdateInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  serviceHostUrl?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<PackageInput>>;
};

export type StateEntity = CoreBaseEntity & {
  __typename?: 'StateEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  countryId: Scalars['String'];
  commonStatus: CommonStatus;
  country: CountryEntity;
  city: Array<CityEntity>;
};

export type StateInput = {
  name?: Maybe<Scalars['String']>;
  countryID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type SubscriptionEntity = CoreBaseEntity & {
  __typename?: 'SubscriptionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  packageId?: Maybe<Scalars['String']>;
  softwareId: Scalars['String'];
  subscriptionAmt: Scalars['Float'];
  salesOrderNo: Scalars['String'];
  remark: Scalars['String'];
  terminationReason?: Maybe<Scalars['String']>;
  isTerminated: Scalars['Boolean'];
  saleOrderDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  noOfUser: Scalars['Float'];
  entityControl?: Maybe<Scalars['JSON']>;
  commonStatus: CommonStatus;
  /** CustomFieldResolver */
  daysToGo: Scalars['Float'];
  account: AccountEntity;
  software: SoftwareEntity;
  package: PackageEntity;
};

export type SubscriptionInput = {
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  subscriptionAmt: Scalars['Float'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  noOfUser: Scalars['Float'];
  saleOrderDate: Scalars['DateTime'];
  salesOrderNo: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  entityControl: EntityContol;
};

export type SubscriptionUpdateInput = {
  ID?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  subscriptionAmt?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  noOfUser?: Maybe<Scalars['Float']>;
  saleOrderDate?: Maybe<Scalars['DateTime']>;
  salesOrderNo?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  entityControl?: Maybe<EntityContol>;
  terminationReason?: Maybe<Scalars['String']>;
  isTerminated?: Maybe<Scalars['Boolean']>;
};

export type TenantListOutput = {
  __typename?: 'TenantListOutput';
  did: Scalars['String'];
  RegisterDate: Scalars['DateTime'];
  TenantName?: Maybe<Scalars['String']>;
  contractLotNo?: Maybe<Scalars['String']>;
  recordstatus?: Maybe<Scalars['String']>;
  ContractStart?: Maybe<Scalars['String']>;
  ContractEnd?: Maybe<Scalars['String']>;
};

export type TenantPaymentTransactionsOutput = {
  __typename?: 'TenantPaymentTransactionsOutput';
  amount: Scalars['Float'];
  count: Scalars['Float'];
  month: Scalars['String'];
};

export type TenantUserRoleOutput = {
  __typename?: 'TenantUserRoleOutput';
  roleId: Scalars['String'];
  roleName: Scalars['String'];
  lAccountName?: Maybe<Scalars['String']>;
  lPropertyName?: Maybe<Scalars['String']>;
  lContractLotNo?: Maybe<Scalars['String']>;
};

export type TermsConditionsEntity = {
  __typename?: 'TermsConditionsEntity';
  name: Scalars['String'];
  softwareId: Scalars['String'];
  accountId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  account: AccountEntity;
  software: SoftwareEntity;
};

export type TermsConditionsInput = {
  name: Scalars['String'];
  softwareId: Scalars['String'];
  accountId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
};

export type TestPassword = CoreBaseEntity & {
  __typename?: 'TestPassword';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
};

export type Unit = {
  __typename?: 'Unit';
  unitId?: Maybe<Scalars['Float']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type UnitModel = {
  __typename?: 'UnitModel';
  unitId?: Maybe<Scalars['Float']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type UpdateAuditInput = {
  modBy?: Maybe<Scalars['String']>;
};

export type UpdateServiceRequestModel = {
  propertyId: Scalars['Float'];
  unitNo?: Maybe<Scalars['String']>;
  requestId: Scalars['String'];
  unitId?: Maybe<Scalars['Float']>;
  publicAreaDesc?: Maybe<Scalars['String']>;
  requestType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UpdateUserInput = {
  name?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  superUser?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  softwareInfo?: Maybe<Array<SoftwareInfo>>;
};


export type UserAccSoftwareEntity = CoreBaseEntity & {
  __typename?: 'UserAccSoftwareEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  userId: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  tokenVersion?: Maybe<Scalars['Float']>;
  lUserId?: Maybe<Scalars['Float']>;
  lDebtorId?: Maybe<Scalars['Float']>;
  lCompanyId?: Maybe<Scalars['Float']>;
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  activatedDate?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  account: AccountEntity;
  user: UserEntity;
  software: SoftwareEntity;
};

export type UserActionLogEntity = {
  __typename?: 'UserActionLogEntity';
  ID: Scalars['String'];
  softwareId?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  actionId?: Maybe<Scalars['String']>;
  actionName?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  loginDateTime?: Maybe<Scalars['DateTime']>;
};

export type UserCountSummary = {
  __typename?: 'UserCountSummary';
  totalActiveUser: Scalars['Float'];
  totalUser: Scalars['Float'];
};

export type UserEntity = CoreBaseEntity & {
  __typename?: 'UserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['JSON']>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  superUser: Scalars['Boolean'];
  pwdHistory?: Maybe<Scalars['JSON']>;
  is2FA: Scalars['Boolean'];
  totpSecret?: Maybe<Scalars['String']>;
  loginAttempt: Scalars['Float'];
  blockDuration: Scalars['Float'];
  blockCount: Scalars['Float'];
  loginTs?: Maybe<Scalars['DateTime']>;
  deviceIP?: Maybe<Scalars['String']>;
  softwareAccount: Array<UserAccSoftwareEntity>;
  roleUsers?: Maybe<Array<RoleUserEntity>>;
  paymentTransactions?: Maybe<Array<SPaymentTransaction>>;
  userNewsFeed?: Maybe<NewsFeedEntity>;
  account: Array<AccountEntity>;
  software: Array<SoftwareEntity>;
  tenantAccountName: Scalars['String'];
};

export type UserInput = {
  name: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  contactNo: Scalars['String'];
  address?: Maybe<AddressInput>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
  superUser?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
  softwareInfo: Array<SoftwareInfo>;
};

export type UserOutput = {
  __typename?: 'UserOutput';
  userName?: Maybe<Scalars['String']>;
  handPhone?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  loginName?: Maybe<Scalars['String']>;
  companyData?: Maybe<CompanyData>;
  userId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
};

export type UserRoleAssignmentInput = {
  roleId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type LastAssignToOfServiceRequestDataLoaderInput = {
  __typename?: 'lastAssignToOfServiceRequestDataLoaderInput';
  lastAssignId: Scalars['Float'];
  accountId: Scalars['String'];
};

export type TenantInfo = {
  __typename?: 'tenantInfo';
  DebtorID: Scalars['Float'];
  AccountName: Scalars['String'];
  ContractLotNo: Scalars['String'];
};

export type TenantNameOfServiceRequestDataLoaderInput = {
  __typename?: 'tenantNameOfServiceRequestDataLoaderInput';
  debtorId: Scalars['Float'];
  accountId: Scalars['String'];
};

export type UnitOfServiceRequestDataLoaderInput = {
  __typename?: 'unitOfServiceRequestDataLoaderInput';
  unitId: Scalars['Float'];
  accountId: Scalars['String'];
};

export type GetUserPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPermissionQuery = (
  { __typename?: 'Query' }
  & { getUserRoleByUserId?: Maybe<Array<(
    { __typename?: 'RoleEntity' }
    & Pick<RoleEntity, 'name'>
    & { permissions?: Maybe<Array<(
      { __typename?: 'PermissionRoleEntity' }
      & Pick<PermissionRoleEntity, 'permissionCode'>
    )>> }
  )>> }
);

export type GetLatestPostDateQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  IsFindLatestPostDate?: Maybe<Scalars['Boolean']>;
}>;


export type GetLatestPostDateQuery = (
  { __typename?: 'Query' }
  & { getAnnouncementsByPropertyId?: Maybe<Array<(
    { __typename?: 'NewsFeedEntity' }
    & Pick<NewsFeedEntity, 'ID' | 'feedTitle' | 'feedContent' | 'feedStatus' | 'publishDate' | 'hasExpiry' | 'isPostToAll' | 'expiryDate'>
    & { createdByUser?: Maybe<(
      { __typename?: 'UserEntity' }
      & Pick<UserEntity, 'name'>
    )>, attachment?: Maybe<(
      { __typename?: 'AttachmentEntity' }
      & Pick<AttachmentEntity, 'fileName' | 'bucketFileName' | 'mediaType' | 'resourceUrl'>
    )>, newsFeedReadStatus?: Maybe<(
      { __typename?: 'NewsFeedReadStatusEntity' }
      & Pick<NewsFeedReadStatusEntity, 'createdBy' | 'newsFeedId'>
    )> }
  )>> }
);

export type GetAnnouncementByIdQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetAnnouncementByIdQuery = (
  { __typename?: 'Query' }
  & { getAnnouncementById: (
    { __typename?: 'NewsFeedEntity' }
    & Pick<NewsFeedEntity, 'ID' | 'feedContent' | 'feedStatus' | 'feedTitle' | 'expiryDate' | 'hasExpiry' | 'isPostToAll' | 'publishDate' | 'startDate'>
    & { createdByUser?: Maybe<(
      { __typename?: 'UserEntity' }
      & Pick<UserEntity, 'name'>
    )>, attachment?: Maybe<(
      { __typename?: 'AttachmentEntity' }
      & Pick<AttachmentEntity, 'ID' | 'resourceUrl' | 'fileName' | 'mediaType'>
    )> }
  ) }
);

export type AddNewsFeedMutationVariables = Exact<{
  input: NewsFeedInputType;
}>;


export type AddNewsFeedMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addNewsFeed'>
);

export type UpdateNewsFeedMutationVariables = Exact<{
  NewsFeedId: Scalars['String'];
  Input: NewsFeedInputType;
}>;


export type UpdateNewsFeedMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateNewsFeed'>
);

export type UpdateFeedStatusMutationVariables = Exact<{
  NewsFeedId: Scalars['String'];
  Status: Scalars['String'];
}>;


export type UpdateFeedStatusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateFeedStatus'>
);

export type GetTenantRegisteredCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantRegisteredCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getTenantRegisteredCount'>
);

export type CreateServiceRequestMutationVariables = Exact<{
  input: ServiceRequestInputModel;
}>;


export type CreateServiceRequestMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createServiceRequest'>
);

export type GetRequestByRequestIdQueryVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type GetRequestByRequestIdQuery = (
  { __typename?: 'Query' }
  & { serviceRequestById?: Maybe<(
    { __typename?: 'ServiceRequest' }
    & Pick<ServiceRequest, 'ID' | 'requestNo' | 'requestStatus' | 'lUnitId' | 'unitNo' | 'tenantName' | 'requestTitle' | 'requesterName' | 'requesterContact' | 'lastAssignTo' | 'nextFollowUpDate'>
    & { requestTime: ServiceRequest['createdTs'], requestType: ServiceRequest['requestTypeId'], areaDescription: ServiceRequest['publicAreaId'] }
    & { createdUser?: Maybe<(
      { __typename?: 'UserEntity' }
      & Pick<UserEntity, 'name'>
    )>, requestTypeData?: Maybe<(
      { __typename?: 'RequestType' }
      & Pick<RequestType, 'name'>
    )>, publicAreaData?: Maybe<(
      { __typename?: 'RequestPublicArea' }
      & Pick<RequestPublicArea, 'name'>
    )>, serviceDetails: Array<(
      { __typename?: 'ServiceDetail' }
      & Pick<ServiceDetail, 'ID' | 'message'>
      & { attachment?: Maybe<(
        { __typename?: 'AttachmentEntity' }
        & Pick<AttachmentEntity, 'ID' | 'mediaType' | 'fileName' | 'bucketFileName' | 'resourceUrl'>
      )> }
    )>, serviceRequestQuotationCount?: Maybe<(
      { __typename?: 'ServiceRequestQuotationCount' }
      & Pick<ServiceRequestQuotationCount, 'ID' | 'quotationCount'>
    )>, requestLogs: Array<(
      { __typename?: 'RequestLog' }
      & Pick<RequestLog, 'ID' | 'createdTs'>
      & { requestActivity?: Maybe<(
        { __typename?: 'RequestActivity' }
        & Pick<RequestActivity, 'ID'>
        & { requestQuotation?: Maybe<(
          { __typename?: 'RequestQuotation' }
          & Pick<RequestQuotation, 'ID' | 'operatorName' | 'operatorContactNo' | 'operatorEmail'>
          & { attachment?: Maybe<(
            { __typename?: 'AttachmentEntity' }
            & Pick<AttachmentEntity, 'ID' | 'fileName' | 'resourceUrl'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type GetServiceRequestInputDataQueryVariables = Exact<{
  propertyId: Scalars['Float'];
}>;


export type GetServiceRequestInputDataQuery = (
  { __typename?: 'Query' }
  & { GetServiceRequestInputData: (
    { __typename?: 'CreateServiceRequestCriteria' }
    & Pick<CreateServiceRequestCriteria, 'requestType' | 'publicArea' | 'serviceRequestAreaType'>
    & { assignTo: Array<(
      { __typename?: 'AssignTo' }
      & Pick<AssignTo, 'name' | 'ID'>
    )>, tenantInfo?: Maybe<Array<(
      { __typename?: 'tenantInfo' }
      & Pick<TenantInfo, 'DebtorID' | 'AccountName' | 'ContractLotNo'>
    )>>, units?: Maybe<Array<(
      { __typename?: 'UnitModel' }
      & Pick<UnitModel, 'unitId' | 'unitNo'>
    )>> }
  ) }
);

export type GetServiceRequestSummaryByPropertyIdQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
}>;


export type GetServiceRequestSummaryByPropertyIdQuery = (
  { __typename?: 'Query' }
  & { serviceRequestSummaryByPropertyId?: Maybe<(
    { __typename?: 'ServiceRequestSummary' }
    & Pick<ServiceRequestSummary, 'lPropertyId' | 'reportedCount' | 'inProgressCount' | 'resolvedCount' | 'closedCount'>
  )> }
);

export type GetRequestLogByRequestIdQueryVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type GetRequestLogByRequestIdQuery = (
  { __typename?: 'Query' }
  & { serviceRequestById?: Maybe<(
    { __typename?: 'ServiceRequest' }
    & Pick<ServiceRequest, 'ID' | 'unitNo' | 'requestNo' | 'createdTs' | 'requestStatus' | 'nextFollowUpDate'>
    & { areaDescription: ServiceRequest['publicAreaId'] }
    & { requestTypeData?: Maybe<(
      { __typename?: 'RequestType' }
      & Pick<RequestType, 'name'>
    )>, publicAreaData?: Maybe<(
      { __typename?: 'RequestPublicArea' }
      & Pick<RequestPublicArea, 'name'>
    )>, requestLogs: Array<(
      { __typename?: 'RequestLog' }
      & Pick<RequestLog, 'ID' | 'logMall' | 'createdTs' | 'requestStatus'>
      & { requestActivity?: Maybe<(
        { __typename?: 'RequestActivity' }
        & Pick<RequestActivity, 'ID' | 'numberOfAttachment'>
        & { assignTo: (
          { __typename?: 'UserEntity' }
          & Pick<UserEntity, 'name'>
        ), requestFollowUp?: Maybe<(
          { __typename?: 'RequestFollowUp' }
          & Pick<RequestFollowUp, 'ID' | 'numberOfAttachment'>
        )>, requestQuotation?: Maybe<(
          { __typename?: 'RequestQuotation' }
          & Pick<RequestQuotation, 'ID' | 'numberOfAttachment'>
        )>, requestEstimation?: Maybe<(
          { __typename?: 'RequestEstimation' }
          & Pick<RequestEstimation, 'ID' | 'numberOfAttachment'>
        )> }
      )> }
    )> }
  )> }
);

export type GetRequestActivityByIdQueryVariables = Exact<{
  ActivityId: Scalars['String'];
}>;


export type GetRequestActivityByIdQuery = (
  { __typename?: 'Query' }
  & { requestActivityById?: Maybe<(
    { __typename?: 'RequestActivity' }
    & Pick<RequestActivity, 'ID' | 'requestStatus' | 'remark' | 'createdTs'>
    & { assignTo: (
      { __typename?: 'UserEntity' }
      & Pick<UserEntity, 'ID' | 'name'>
    ), attachment?: Maybe<Array<(
      { __typename?: 'AttachmentEntity' }
      & Pick<AttachmentEntity, 'ID' | 'fileName' | 'mediaType' | 'resourceUrl'>
    )>>, requestFollowUp?: Maybe<(
      { __typename?: 'RequestFollowUp' }
      & Pick<RequestFollowUp, 'ID' | 'activityDate' | 'appointDate'>
      & { attachment?: Maybe<Array<(
        { __typename?: 'AttachmentEntity' }
        & Pick<AttachmentEntity, 'ID' | 'fileName' | 'mediaType' | 'resourceUrl'>
      )>> }
    )>, requestQuotation?: Maybe<(
      { __typename?: 'RequestQuotation' }
      & Pick<RequestQuotation, 'ID' | 'isProceed' | 'reason' | 'operatorName' | 'operatorContactNo' | 'operatorEmail'>
      & { attachment?: Maybe<(
        { __typename?: 'AttachmentEntity' }
        & Pick<AttachmentEntity, 'ID' | 'fileName' | 'mediaType' | 'resourceUrl'>
      )> }
    )>, requestEstimation?: Maybe<(
      { __typename?: 'RequestEstimation' }
      & Pick<RequestEstimation, 'ID' | 'processDate' | 'completeDate' | 'durationDay' | 'durationHour'>
      & { attachment?: Maybe<Array<(
        { __typename?: 'AttachmentEntity' }
        & Pick<AttachmentEntity, 'ID' | 'fileName' | 'mediaType' | 'resourceUrl'>
      )>> }
    )> }
  )> }
);

export type GetRequestActvityAttachmentQueryVariables = Exact<{
  input: AttachmentByRefIdAndRefTableInput;
}>;


export type GetRequestActvityAttachmentQuery = (
  { __typename?: 'Query' }
  & { AttachmentByRefIdAndRefTable?: Maybe<Array<(
    { __typename?: 'AttachmentEntity' }
    & Pick<AttachmentEntity, 'ID' | 'mediaType' | 'resourceUrl' | 'fileName' | 'fileSize'>
  )>> }
);

export type GetFilteredServiceRequestListingQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  RequestStatus: Array<Scalars['String']> | Scalars['String'];
  OrderBy: Scalars['String'];
  RequestType: Scalars['String'];
  LastAssignTo: Scalars['String'];
}>;


export type GetFilteredServiceRequestListingQuery = (
  { __typename?: 'Query' }
  & { filteredServiceRequestByPropertyId?: Maybe<Array<(
    { __typename?: 'ServiceRequest' }
    & Pick<ServiceRequest, 'ID' | 'requestNo' | 'requestTitle' | 'createdTs' | 'requestStatus' | 'lDebtorId' | 'unitNo' | 'tenantName' | 'lastAssignTo'>
    & { requestType: ServiceRequest['requestTypeId'], areaDescription: ServiceRequest['publicAreaId'] }
    & { serviceRequestQuotationCount?: Maybe<(
      { __typename?: 'ServiceRequestQuotationCount' }
      & Pick<ServiceRequestQuotationCount, 'ID' | 'quotationCount'>
    )>, requestTypeData?: Maybe<(
      { __typename?: 'RequestType' }
      & Pick<RequestType, 'name'>
    )>, publicAreaData?: Maybe<(
      { __typename?: 'RequestPublicArea' }
      & Pick<RequestPublicArea, 'name'>
    )> }
  )>> }
);

export type GetQuotationByRequestIdQueryVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type GetQuotationByRequestIdQuery = (
  { __typename?: 'Query' }
  & { serviceRequestById?: Maybe<(
    { __typename?: 'ServiceRequest' }
    & Pick<ServiceRequest, 'ID' | 'unitNo' | 'requestNo' | 'createdTs' | 'requestStatus'>
    & { areaDescription: ServiceRequest['publicAreaId'] }
    & { requestActivities?: Maybe<Array<(
      { __typename?: 'RequestActivity' }
      & { requestQuotation?: Maybe<(
        { __typename?: 'RequestQuotation' }
        & Pick<RequestQuotation, 'ID' | 'operatorName' | 'operatorContactNo' | 'operatorEmail' | 'isProceed'>
        & { attachment?: Maybe<(
          { __typename?: 'AttachmentEntity' }
          & Pick<AttachmentEntity, 'ID' | 'mediaType' | 'fileName' | 'resourceUrl' | 'fileSize'>
        )> }
      )> }
    )>> }
  )> }
);

export type GetServiceRequestActivityInputQueryVariables = Exact<{
  lPropertyId: Scalars['Float'];
  serviceRequestId: Scalars['String'];
}>;


export type GetServiceRequestActivityInputQuery = (
  { __typename?: 'Query' }
  & { getServiceRequestActivityInput: (
    { __typename?: 'ServiceRequestActivityCriteria' }
    & Pick<ServiceRequestActivityCriteria, 'srActivityCategory' | 'srStatus' | 'requestCreatedDate'>
    & { assignTo: Array<(
      { __typename?: 'AssignTo' }
      & Pick<AssignTo, 'ID' | 'name'>
    )> }
  ) }
);

export type CreateRequestActivityMutationVariables = Exact<{
  input: RequestActivityInputModel;
}>;


export type CreateRequestActivityMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createRequestActivity'>
);

export type GetServiceRequestUpdateInputQueryVariables = Exact<{
  input: GetUpdateServiceRequestModel;
}>;


export type GetServiceRequestUpdateInputQuery = (
  { __typename?: 'Query' }
  & { getServiceRequestUpdateInput: (
    { __typename?: 'ServiceRequestUpdateCriteria' }
    & Pick<ServiceRequestUpdateCriteria, 'publicArea' | 'requestType' | 'serviceRequestAreaType'>
    & { units?: Maybe<Array<(
      { __typename?: 'UnitModel' }
      & Pick<UnitModel, 'unitId' | 'unitNo'>
    )>> }
  ) }
);

export type UpdateServiceRequestMutationVariables = Exact<{
  UpdateServiceRequestModel: UpdateServiceRequestModel;
}>;


export type UpdateServiceRequestMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateServiceRequest'>
);

export type InsertDownloadLogMutationVariables = Exact<{
  fileSize: Scalars['Float'];
  fileName: Scalars['String'];
  attachmentId?: Maybe<Scalars['String']>;
  path: Scalars['String'];
}>;


export type InsertDownloadLogMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'insertDownloadLog'>
);

export type GetCloudRequestTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCloudRequestTypeQuery = (
  { __typename?: 'Query' }
  & { getCloudRequestType: Array<(
    { __typename?: 'RequestType' }
    & Pick<RequestType, 'name' | 'seqNo' | 'ID'>
  )> }
);

export type GetCloudPublicAreaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCloudPublicAreaQuery = (
  { __typename?: 'Query' }
  & { getCloudPublicArea: Array<(
    { __typename?: 'RequestPublicArea' }
    & Pick<RequestPublicArea, 'name' | 'seqNo' | 'ID'>
  )> }
);

export type AttachmentDownloadQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type AttachmentDownloadQuery = (
  { __typename?: 'Query' }
  & { AttachmentDownload?: Maybe<(
    { __typename?: 'FilesOutput' }
    & Pick<FilesOutput, 'base64File'>
  )> }
);

export const GetUserPermissionDocument = gql`
    query GetUserPermission {
  getUserRoleByUserId {
    name
    permissions {
      permissionCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserPermissionGQL extends Apollo.Query<GetUserPermissionQuery, GetUserPermissionQueryVariables> {
    document = GetUserPermissionDocument;
    client = 'cloud';
  }
export const GetLatestPostDateDocument = gql`
    query GetLatestPostDate($PropertyId: Float!, $IsFindLatestPostDate: Boolean) {
  getAnnouncementsByPropertyId(
    PropertyId: $PropertyId
    IsFindLatestPostDate: $IsFindLatestPostDate
  ) {
    ID
    feedTitle
    feedContent
    feedStatus
    publishDate
    hasExpiry
    isPostToAll
    expiryDate
    createdByUser {
      name
    }
    attachment {
      fileName
      bucketFileName
      mediaType
      resourceUrl
    }
    newsFeedReadStatus {
      createdBy
      newsFeedId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLatestPostDateGQL extends Apollo.Query<GetLatestPostDateQuery, GetLatestPostDateQueryVariables> {
    document = GetLatestPostDateDocument;
    client = 'cloud';
  }
export const GetAnnouncementByIdDocument = gql`
    query GetAnnouncementById($ID: String!) {
  getAnnouncementById(id: $ID) {
    ID
    feedContent
    feedStatus
    feedTitle
    expiryDate
    hasExpiry
    isPostToAll
    publishDate
    startDate
    createdByUser {
      name
    }
    attachment {
      ID
      resourceUrl
      fileName
      mediaType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAnnouncementByIdGQL extends Apollo.Query<GetAnnouncementByIdQuery, GetAnnouncementByIdQueryVariables> {
    document = GetAnnouncementByIdDocument;
    client = 'cloud';
  }
export const AddNewsFeedDocument = gql`
    mutation AddNewsFeed($input: NewsFeedInputType!) {
  addNewsFeed(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNewsFeedGQL extends Apollo.Mutation<AddNewsFeedMutation, AddNewsFeedMutationVariables> {
    document = AddNewsFeedDocument;
    client = 'cloud';
  }
export const UpdateNewsFeedDocument = gql`
    mutation UpdateNewsFeed($NewsFeedId: String!, $Input: NewsFeedInputType!) {
  updateNewsFeed(NewsFeedId: $NewsFeedId, Input: $Input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNewsFeedGQL extends Apollo.Mutation<UpdateNewsFeedMutation, UpdateNewsFeedMutationVariables> {
    document = UpdateNewsFeedDocument;
    client = 'cloud';
  }
export const UpdateFeedStatusDocument = gql`
    mutation UpdateFeedStatus($NewsFeedId: String!, $Status: String!) {
  updateFeedStatus(NewsFeedId: $NewsFeedId, Status: $Status)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFeedStatusGQL extends Apollo.Mutation<UpdateFeedStatusMutation, UpdateFeedStatusMutationVariables> {
    document = UpdateFeedStatusDocument;
    client = 'cloud';
  }
export const GetTenantRegisteredCountDocument = gql`
    query getTenantRegisteredCount {
  getTenantRegisteredCount
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTenantRegisteredCountGQL extends Apollo.Query<GetTenantRegisteredCountQuery, GetTenantRegisteredCountQueryVariables> {
    document = GetTenantRegisteredCountDocument;
    client = 'cloud';
  }
export const CreateServiceRequestDocument = gql`
    mutation createServiceRequest($input: ServiceRequestInputModel!) {
  createServiceRequest(SRInput: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateServiceRequestGQL extends Apollo.Mutation<CreateServiceRequestMutation, CreateServiceRequestMutationVariables> {
    document = CreateServiceRequestDocument;
    client = 'cloud';
  }
export const GetRequestByRequestIdDocument = gql`
    query GetRequestByRequestId($requestId: String!) {
  serviceRequestById(RequestId: $requestId) {
    ID
    requestNo
    requestTime: createdTs
    requestStatus
    lUnitId
    unitNo
    tenantName
    requestTitle
    requestType: requestTypeId
    areaDescription: publicAreaId
    requesterName
    requesterContact
    lastAssignTo
    nextFollowUpDate
    createdUser {
      name
    }
    requestTypeData {
      name
    }
    publicAreaData {
      name
    }
    serviceDetails {
      ID
      message
      attachment {
        ID
        mediaType
        fileName
        bucketFileName
        resourceUrl
      }
    }
    serviceRequestQuotationCount {
      ID
      quotationCount
    }
    requestLogs {
      ID
      createdTs
      requestActivity {
        ID
        requestQuotation {
          ID
          operatorName
          operatorContactNo
          operatorEmail
          attachment {
            ID
            fileName
            resourceUrl
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRequestByRequestIdGQL extends Apollo.Query<GetRequestByRequestIdQuery, GetRequestByRequestIdQueryVariables> {
    document = GetRequestByRequestIdDocument;
    client = 'cloud';
  }
export const GetServiceRequestInputDataDocument = gql`
    query GetServiceRequestInputData($propertyId: Float!) {
  GetServiceRequestInputData(PropertyId: $propertyId) {
    assignTo {
      name
      ID
    }
    requestType
    publicArea
    serviceRequestAreaType
    tenantInfo {
      DebtorID
      AccountName
      ContractLotNo
    }
    units {
      unitId
      unitNo
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetServiceRequestInputDataGQL extends Apollo.Query<GetServiceRequestInputDataQuery, GetServiceRequestInputDataQueryVariables> {
    document = GetServiceRequestInputDataDocument;
    client = 'cloud';
  }
export const GetServiceRequestSummaryByPropertyIdDocument = gql`
    query getServiceRequestSummaryByPropertyId($PropertyId: Float!) {
  serviceRequestSummaryByPropertyId(PropertyId: $PropertyId) {
    lPropertyId
    reportedCount
    inProgressCount
    resolvedCount
    closedCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetServiceRequestSummaryByPropertyIdGQL extends Apollo.Query<GetServiceRequestSummaryByPropertyIdQuery, GetServiceRequestSummaryByPropertyIdQueryVariables> {
    document = GetServiceRequestSummaryByPropertyIdDocument;
    client = 'cloud';
  }
export const GetRequestLogByRequestIdDocument = gql`
    query getRequestLogByRequestId($requestId: String!) {
  serviceRequestById(RequestId: $requestId) {
    ID
    unitNo
    requestNo
    areaDescription: publicAreaId
    createdTs
    requestStatus
    nextFollowUpDate
    requestTypeData {
      name
    }
    publicAreaData {
      name
    }
    requestLogs {
      ID
      logMall
      createdTs
      requestStatus
      requestActivity {
        assignTo {
          name
        }
        ID
        numberOfAttachment
        requestFollowUp {
          ID
          numberOfAttachment
        }
        requestQuotation {
          ID
          numberOfAttachment
        }
        requestEstimation {
          ID
          numberOfAttachment
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRequestLogByRequestIdGQL extends Apollo.Query<GetRequestLogByRequestIdQuery, GetRequestLogByRequestIdQueryVariables> {
    document = GetRequestLogByRequestIdDocument;
    client = 'cloud';
  }
export const GetRequestActivityByIdDocument = gql`
    query GetRequestActivityById($ActivityId: String!) {
  requestActivityById(ActivityId: $ActivityId) {
    ID
    requestStatus
    remark
    createdTs
    assignTo {
      ID
      name
    }
    attachment {
      ID
      fileName
      mediaType
      resourceUrl
    }
    requestFollowUp {
      ID
      activityDate
      appointDate
      attachment {
        ID
        fileName
        mediaType
        resourceUrl
      }
    }
    requestQuotation {
      ID
      isProceed
      reason
      operatorName
      operatorContactNo
      operatorEmail
      attachment {
        ID
        fileName
        mediaType
        resourceUrl
      }
    }
    requestEstimation {
      ID
      processDate
      completeDate
      durationDay
      durationHour
      attachment {
        ID
        fileName
        mediaType
        resourceUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRequestActivityByIdGQL extends Apollo.Query<GetRequestActivityByIdQuery, GetRequestActivityByIdQueryVariables> {
    document = GetRequestActivityByIdDocument;
    client = 'cloud';
  }
export const GetRequestActvityAttachmentDocument = gql`
    query getRequestActvityAttachment($input: AttachmentByRefIdAndRefTableInput!) {
  AttachmentByRefIdAndRefTable(input: $input) {
    ID
    mediaType
    resourceUrl
    fileName
    fileSize
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRequestActvityAttachmentGQL extends Apollo.Query<GetRequestActvityAttachmentQuery, GetRequestActvityAttachmentQueryVariables> {
    document = GetRequestActvityAttachmentDocument;
    client = 'cloud';
  }
export const GetFilteredServiceRequestListingDocument = gql`
    query getFilteredServiceRequestListing($PropertyId: Float!, $RequestStatus: [String!]!, $OrderBy: String!, $RequestType: String!, $LastAssignTo: String!) {
  filteredServiceRequestByPropertyId(
    PropertyId: $PropertyId
    RequestStatus: $RequestStatus
    OrderBy: $OrderBy
    RequestType: $RequestType
    LastAssignTo: $LastAssignTo
  ) {
    ID
    requestNo
    requestTitle
    requestType: requestTypeId
    createdTs
    requestStatus
    lDebtorId
    unitNo
    tenantName
    lastAssignTo
    areaDescription: publicAreaId
    serviceRequestQuotationCount {
      ID
      quotationCount
    }
    requestTypeData {
      name
    }
    publicAreaData {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFilteredServiceRequestListingGQL extends Apollo.Query<GetFilteredServiceRequestListingQuery, GetFilteredServiceRequestListingQueryVariables> {
    document = GetFilteredServiceRequestListingDocument;
    client = 'cloud';
  }
export const GetQuotationByRequestIdDocument = gql`
    query GetQuotationByRequestId($requestId: String!) {
  serviceRequestById(RequestId: $requestId) {
    ID
    unitNo
    requestNo
    areaDescription: publicAreaId
    createdTs
    requestStatus
    requestActivities {
      requestQuotation {
        ID
        operatorName
        operatorContactNo
        operatorEmail
        isProceed
        attachment {
          ID
          mediaType
          fileName
          resourceUrl
          fileSize
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetQuotationByRequestIdGQL extends Apollo.Query<GetQuotationByRequestIdQuery, GetQuotationByRequestIdQueryVariables> {
    document = GetQuotationByRequestIdDocument;
    client = 'cloud';
  }
export const GetServiceRequestActivityInputDocument = gql`
    query getServiceRequestActivityInput($lPropertyId: Float!, $serviceRequestId: String!) {
  getServiceRequestActivityInput(
    lPropertyId: $lPropertyId
    serviceRequestId: $serviceRequestId
  ) {
    assignTo {
      ID
      name
    }
    srActivityCategory
    srStatus
    requestCreatedDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetServiceRequestActivityInputGQL extends Apollo.Query<GetServiceRequestActivityInputQuery, GetServiceRequestActivityInputQueryVariables> {
    document = GetServiceRequestActivityInputDocument;
    client = 'cloud';
  }
export const CreateRequestActivityDocument = gql`
    mutation createRequestActivity($input: RequestActivityInputModel!) {
  createRequestActivity(RequestActivityInput: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRequestActivityGQL extends Apollo.Mutation<CreateRequestActivityMutation, CreateRequestActivityMutationVariables> {
    document = CreateRequestActivityDocument;
    client = 'cloud';
  }
export const GetServiceRequestUpdateInputDocument = gql`
    query getServiceRequestUpdateInput($input: GetUpdateServiceRequestModel!) {
  getServiceRequestUpdateInput(input: $input) {
    publicArea
    requestType
    units {
      unitId
      unitNo
    }
    serviceRequestAreaType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetServiceRequestUpdateInputGQL extends Apollo.Query<GetServiceRequestUpdateInputQuery, GetServiceRequestUpdateInputQueryVariables> {
    document = GetServiceRequestUpdateInputDocument;
    client = 'cloud';
  }
export const UpdateServiceRequestDocument = gql`
    mutation updateServiceRequest($UpdateServiceRequestModel: UpdateServiceRequestModel!) {
  updateServiceRequest(UpdateServiceRequestModel: $UpdateServiceRequestModel)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateServiceRequestGQL extends Apollo.Mutation<UpdateServiceRequestMutation, UpdateServiceRequestMutationVariables> {
    document = UpdateServiceRequestDocument;
    client = 'cloud';
  }
export const InsertDownloadLogDocument = gql`
    mutation insertDownloadLog($fileSize: Float!, $fileName: String!, $attachmentId: String, $path: String!) {
  insertDownloadLog(
    attachmentId: $attachmentId
    path: $path
    fileSize: $fileSize
    fileName: $fileName
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertDownloadLogGQL extends Apollo.Mutation<InsertDownloadLogMutation, InsertDownloadLogMutationVariables> {
    document = InsertDownloadLogDocument;
    client = 'cloud';
  }
export const GetCloudRequestTypeDocument = gql`
    query getCloudRequestType {
  getCloudRequestType {
    name
    seqNo
    ID
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCloudRequestTypeGQL extends Apollo.Query<GetCloudRequestTypeQuery, GetCloudRequestTypeQueryVariables> {
    document = GetCloudRequestTypeDocument;
    client = 'cloud';
  }
export const GetCloudPublicAreaDocument = gql`
    query getCloudPublicArea {
  getCloudPublicArea {
    name
    seqNo
    ID
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCloudPublicAreaGQL extends Apollo.Query<GetCloudPublicAreaQuery, GetCloudPublicAreaQueryVariables> {
    document = GetCloudPublicAreaDocument;
    client = 'cloud';
  }
export const AttachmentDownloadDocument = gql`
    query AttachmentDownload($url: String!) {
  AttachmentDownload(url: $url) {
    base64File
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AttachmentDownloadGQL extends Apollo.Query<AttachmentDownloadQuery, AttachmentDownloadQueryVariables> {
    document = AttachmentDownloadDocument;
    client = 'cloud';
  }